import { useCallback } from "react";

import type { ReservationDetailUpdateMailResendRequestInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { RESERVATION_DETAIL_UPDATE_MAIL_RESEND_REQUEST_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_UPDATE_MUTATION } from "./schema";
import * as Shared from "../../../../_shared";

export const useReservationDetailUpdateMailResendRequestUpdateMutation = () => {
	const { mutationFunc } = useCustomMutation(
		RESERVATION_DETAIL_UPDATE_MAIL_RESEND_REQUEST_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_UPDATE_MUTATION,
	);
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const onUpdateReservationDetailUpdateMailResendRequest = useCallback(
		async (input: ReservationDetailUpdateMailResendRequestInput) => {
			showLoadingScreenCallback();
			return mutationFunc({
				variables: { input },
				update: (cache, { data }) => {
					/**
					 * キャッシュから予約詳細を取得
					 */
					const cached = cache.readQuery({
						query: Shared.Model.Repository.Query.RESERVATION_DETAIL_FOR_MANAGEMENT_RESERVATION_ITEM_QUERY,
						variables: { hotelID: input.hotelID, reservationId: input.reservationID },
					});
					/**
					 * レスポンスから更新されたステータスを取得
					 */
					const updated = data?.reservationDetailUpdateMailResendRequest.reservationDetail?.guestEmail;
					if (!cached || updated === undefined) return;

					/**
					 * 予約更新のキャッシュを更新
					 */
					cache.writeQuery({
						query: Shared.Model.Repository.Query.RESERVATION_DETAIL_FOR_MANAGEMENT_RESERVATION_ITEM_QUERY,
						variables: { hotelID: input.hotelID, reservationId: input.reservationID },
						data: {
							reservationDetail: {
								...cached.reservationDetail,
								guestEmail: updated,
							},
							repeaterReservationList: cached.repeaterReservationList,
						},
					});
				},
			})
				.then(({ errors }) => {
					if (!errors) {
						notifyUserEventInfo({
							variant: "default",
							title: "メールアドレスを更新しました",
							description: "メールをご確認ください。",
						});
					}
				})
				.finally(() => {
					hideLoadingScreenCallback();
				});
		},
		[hideLoadingScreenCallback, mutationFunc, showLoadingScreenCallback],
	);

	return {
		onUpdateReservationDetailUpdateMailResendRequest,
	};
};
